import { Action } from 'redux'

export const GET_SERVICE_STATUS = 'GET_SERVICE_STATUS'

export interface GetStatusAction extends Action {
  type: 'GET_SERVICE_STATUS'
}

export default (): GetStatusAction => ({
  type: GET_SERVICE_STATUS
})
